<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>Estadísticas</span>
</mat-toolbar>

<div class="stats-page">
  <p class="stats-subtitle">Explora la evolución del torneo</p>

  <div class="stats-grid">
    <mat-card
      class="stats-card"
      (click)="showEvolution()"
      tabindex="0"
      role="button"
    >
      <div class="stats-card__icon-wrap stats-card__icon-wrap--evolution">
        <mat-icon>show_chart</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="stats-card__title">Evolución</h3>
        <p class="stats-card__desc">
          Sigue jornada a jornada cómo cambia la clasificación.
        </p>
      </mat-card-content>
      <div class="stats-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="stats-card"
      (click)="showSnipers()"
      tabindex="0"
      role="button"
    >
      <div class="stats-card__icon-wrap stats-card__icon-wrap--snipers">
        <mat-icon>gps_fixed</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="stats-card__title">Dianas</h3>
        <p class="stats-card__desc">
          Consulta quién más marcadores exactos lleva acertados.
        </p>
      </mat-card-content>
      <div class="stats-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="stats-card"
      (click)="showBadges()"
      tabindex="0"
      role="button"
    >
      <div class="stats-card__icon-wrap stats-card__icon-wrap--badges">
        <mat-icon>military_tech</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="stats-card__title">Insignias</h3>
        <p class="stats-card__desc">
          Ranking tipo medallero según insignias de oro, plata y bronce.
        </p>
      </mat-card-content>
      <div class="stats-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="stats-card"
      (click)="showScorers()"
      tabindex="0"
      role="button"
    >
      <div class="stats-card__icon-wrap stats-card__icon-wrap--scorers">
        <mat-icon>sports_soccer</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="stats-card__title">Goleadores</h3>
        <p class="stats-card__desc">
          Clasificación de máximos goleadores del Mundial.
        </p>
      </mat-card-content>
      <div class="stats-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>

    <mat-card
      class="stats-card"
      (click)="showGroupStandings()"
      tabindex="0"
      role="button"
    >
      <div class="stats-card__icon-wrap stats-card__icon-wrap--groups">
        <mat-icon>leaderboard</mat-icon>
      </div>
      <mat-card-content>
        <h3 class="stats-card__title">Clasificación de grupos</h3>
        <p class="stats-card__desc">
          Consulta las posiciones oficiales de los grupos del Mundial.
        </p>
      </mat-card-content>
      <div class="stats-card__arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </mat-card>
  </div>
</div>
